import React, { useEffect, useState, useRef } from 'react';
import { db } from '../firebase';
import { collection, getDocs, doc, updateDoc, arrayUnion, getDoc } from 'firebase/firestore';
import { useAuth } from '../AuthContext';
import { useCart } from '../CartContext';
import '../stylesheets/Items.css';
import back from '../img/BackGround (2).png';
import backarrow from '../img/Icons/backarrow.png';

const Items = () => {
  const { user, logout } = useAuth();
  const { addToCart, setCartItems } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 10;
  const [imageHeight, setImageHeight] = useState('0px');
  const mainImageRef = useRef(null);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      const productsCollection = collection(db, 'products');
      const productSnapshot = await getDocs(productsCollection);
      const productList = productSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(productList);
      setLoading(false);
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    if (!user) {
      setCartItems([]);
    }
  }, [user, setCartItems]);

  const handleImageLoad = () => {
    if (mainImageRef.current) {
      const heighto = mainImageRef.current.clientHeight;
      setImageHeight(`${heighto}px`);
    }
  };

  const formatProductName = (productName) => {
    return productName.replace(/\s+/g, '_');
  };

  const getImagePath = (productName, imageName) => {
    const formattedProductName = formatProductName(productName);
    return `/img/items/${formattedProductName}/${imageName}`;
  };

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(products.length / productsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleAddToCart = async (product) => {
    if (!user) {
      alert('Debes iniciar sesión para añadir productos al carrito.');
      return;
    }

    try {
      const userRef = doc(db, 'users', user.uid);
      const userSnapshot = await getDoc(userRef);
      const userData = userSnapshot.data();

      const productWithAmount = {
        ...product,
        amount: 1,
      };

      if (userData && userData.shoppingCart) {
        const productExists = userData.shoppingCart.find(item => item.id === product.id);
        if (productExists) {
          alert('El producto ya está en el carrito.');
          return;
        }
      }

      await updateDoc(userRef, {
        shoppingCart: arrayUnion(productWithAmount),
      });

      addToCart(productWithAmount);
      alert('Producto añadido al carrito.');
    } catch (error) {
      console.error('Error al añadir al carrito:', error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="Items-body">
        <div className='Items-cont'>
          {currentProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="Product-Name-Container">
                <h2 className="Product-Name">{product.ItemName.replace(/_/g, ' ')}</h2>
              </div>
              <div className="images-container">
                <div className="image-row-container" >
                  {product.ItemImages.slice(1, 3).map((image, index) => (
                    <div key={index} className="image-row-cont">
                      <img
                        src={getImagePath(product.ItemName, image)}
                        alt={product.ItemName}
                        className="Item-Image"
                      />
                    </div>
                  ))}
                </div>
                <div className="image-row-main">
                  <img
                    ref={mainImageRef}
                    src={getImagePath(product.ItemName, product.ItemImages[0])}
                    alt={product.ItemName}
                    className="Item-Image"
                  />
                </div>
                <div className="image-row-container">
                  {product.ItemImages.slice(3, 5).map((image, index) => (
                    <div key={index} className="image-row-cont">
                      <img
                        src={getImagePath(product.ItemName, image)}
                        alt={product.ItemName}
                        className="Item-Image"
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="Product-Buy-Container">
                <p className="Product-Price">${product.ItemPrice.toLocaleString('es-ES')} COP</p>
                <button className="Shopping-Cart" onClick={() => handleAddToCart(product)}>
                  <h4>Añadir al carrito</h4>
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination">
          <div className='btn-cont'>
            <button className='next' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
              <img className='next_img' src={backarrow} alt="" />
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => paginate(i + 1)}
                className={currentPage === i + 1 ? 'active' : 'page'}
              >
                {i + 1}
              </button>
            ))}
            <button className='next' onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
              <img className='next_img flipped' src={backarrow} alt="" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Items;
